import {
  MenuItem,
  Select,
  FormControl,
  Typography,
  SelectChangeEvent,
} from "@mui/material";
import { selectStyle } from "shared/lib/style";

interface OperationSelectProps {
  nameLabel: string;
  placeholder: string;
  arr: { id: string | number; name: string }[];
  selected: string | number | null;
  setSelected: (value: any) => void;
}

const DocumentTypeSelect: React.FC<OperationSelectProps> = ({
  nameLabel,
  placeholder,
  arr,
  selected,
  setSelected,
}) => {
  const handleChange = (event: SelectChangeEvent<string | number>) => {
    setSelected(event.target.value);
  };

  const handleReset = () => {
    setSelected(null);
  };

  return (
    <FormControl fullWidth>
      <div className="label-personalCabinet">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography sx={{ fontSize: "12px" }}>{nameLabel}</Typography>
          {selected !== null && selected !== "" && (
            <Typography
              onClick={handleReset}
              sx={{ cursor: "pointer", fontSize: "12px", color: '#0090d1' }}
            >
              Сбросить
            </Typography>
          )}
        </div>

        <Select
          value={selected ?? ""}
          onChange={handleChange}
          displayEmpty
          sx={selectStyle}
          className={`input-personalCabinet`}
          renderValue={(val) =>
            val !== "" && val !== null ? (
              arr.find((i) => i.id === val)?.name
            ) : (
              <span style={{ color: "rgba(0,0,0,0.25)" }}>
                {placeholder}
              </span>
            )
          }
        >
          {arr.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {item.name}
            </MenuItem>
          ))}
        </Select>
      </div>
    </FormControl >
  );
};

export default DocumentTypeSelect;
